// extracted by mini-css-extract-plugin
export default {"wrapper":"UserCountry_wrapper--iDS","input":"UserCountry_input--Png","icon":"UserCountry_icon--rW2","label":"UserCountry_label--Joe"};